export const times = ['15м', '30м', '1ч', '1ч 30м', '2ч', '4ч', '8ч'];
